import { render, staticRenderFns } from "./ListadoSoluciones.vue?vue&type=template&id=bbca6438&scoped=true&"
import script from "./ListadoSoluciones.vue?vue&type=script&lang=js&"
export * from "./ListadoSoluciones.vue?vue&type=script&lang=js&"
import style0 from "./ListadoSoluciones.vue?vue&type=style&index=0&id=bbca6438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbca6438",
  null
  
)

export default component.exports